const RECAPTCHA_SITE_KEY = process.env.VUE_APP_RECAPTCHA_SITE_KEY || '';

let loaded = false;
let loading = null;

export function loadRecaptcha() {
  if (loaded) return Promise.resolve();
  if (loading) return loading;

  loading = new Promise((resolve, reject) => {
    if (document.querySelector('script[src*="recaptcha/api.js"]')) {
      loaded = true;
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoad&render=explicit`;
    script.async = true;
    script.defer = true;
    window.onRecaptchaLoad = () => { loaded = true; resolve(); };
    script.onerror = () => reject(new Error('Failed to load reCAPTCHA'));
    document.head.appendChild(script);
  });

  return loading;
}

export function renderRecaptcha(containerId, onSuccess, onExpired) {
  return new Promise((resolve, reject) => {
    if (!window.grecaptcha) {
      reject(new Error('reCAPTCHA not loaded'));
      return;
    }
    const widgetId = window.grecaptcha.render(containerId, {
      sitekey: RECAPTCHA_SITE_KEY,
      callback: onSuccess,
      'expired-callback': onExpired,
      theme: 'light',
      size: 'normal',
    });
    resolve(widgetId);
  });
}

export function resetRecaptcha(widgetId) {
  if (window.grecaptcha && widgetId !== null && widgetId !== undefined) {
    window.grecaptcha.reset(widgetId);
  }
}

// Read the current v2 token from a rendered widget. Returns '' if unsolved.
export function getRecaptchaResponse(widgetId) {
  if (window.grecaptcha && widgetId !== null && widgetId !== undefined) {
    return window.grecaptcha.getResponse(widgetId) || '';
  }
  return '';
}


export async function executeRecaptcha() {
  return null;
}